import { flattenArray, getAttributesByIds, getDistinctItems } from '@vista-digital/occ-domain';
import { isHeroAttribute } from '../attribute/utils';
export function getCommonAttributes(allAttributes) {
    const attributeArrays = allAttributes
        .map(showtimeAttrs => getShowtimeAttributesEligibleForGrouping(showtimeAttrs))
        .sort((array1, array2) => array1.length - array2.length);
    if (attributeArrays.length < 2 || attributeArrays.find(element => element.length === 0))
        return [];
    const firstSessionAttributes = attributeArrays[0];
    return firstSessionAttributes.filter(testAttribute => {
        return attributeArrays.slice(1).every(otherSessionAttributes => {
            return otherSessionAttributes.some(sessionAttribute => sessionAttribute.id === testAttribute.id);
        });
    });
}
export const getHeroAttributesForShowtime = (allAttributes, i18n) => {
    const heroes = allAttributes
        .filter(attr => attr.displayPriority === 1 && !attr.isPromoted)
        .sort((a, b) => sortAttributes(a, b, i18n));
    return heroes;
};
export function getPromotedAttributeForShowtime(allAttributes, i18n) {
    if (allAttributes) {
        const promoted = allAttributes.filter(attr => attr.isPromoted).sort((a, b) => sortAttributes(a, b, i18n));
        if (promoted.length > 0)
            return promoted[0];
    }
    return undefined;
}
export const getStandardAttributesForShowtime = (allAttributes, i18n, excludedIds) => {
    return allAttributes
        .filter(attr => {
        if (attr.isPromoted)
            return false;
        if (isHeroAttribute(attr))
            return false;
        if (excludedIds && excludedIds.findIndex(id => id === attr.id) !== -1)
            return false;
        return true;
    })
        .sort((a, b) => sortAttributes(a, b, i18n));
};
function sortAttributes(attribute1, attribute2, i18n) {
    if (attribute1.displayPriority !== attribute2.displayPriority) {
        return attribute1.displayPriority - attribute2.displayPriority;
    }
    return i18n.compareTranslatable(attribute1.shortName, attribute2.shortName);
}
const getShowtimeAttributesEligibleForGrouping = (allAttributes) => {
    return allAttributes.filter(attribute => {
        if (attribute.isPromoted)
            return false;
        if (isHeroAttribute(attribute))
            return false;
        return true;
    });
};
export const getShowtimeAttributes = (showtimes) => {
    const attributeIds = showtimes.map(showtime => showtime.attributeIds).reduce(flattenArray, []);
    const uniqueAttributeIds = getDistinctItems(attributeIds);
    return getAttributesByIds(uniqueAttributeIds);
};
//# sourceMappingURL=utils.js.map